export enum PermissionOwnerType {
    User = "User",
    Group = "Group",
    Resource = "Resource"
}